(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["villani-language-gate"] && !Shopify.designMode) return;
  try {
    (function () {
    function initializeLanguageGate() {
      var gate = document.getElementById('villani-language-gate');
      if (!gate || document.documentElement.classList.contains('villani-language-already-selected')) return;

      var page = document.querySelector('.page-wrapper');
      if (page) page.setAttribute('inert', '');

      var form = gate.querySelector('form');
      if (form) {
        form.addEventListener('submit', function () {
          try {
            window.localStorage.setItem('villani-language-selected', '1');
          } catch (error) {}
        });
      }

      var firstChoice = gate.querySelector('[data-villani-language-choice]');
      if (firstChoice) firstChoice.focus();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeLanguageGate);
    } else {
      initializeLanguageGate();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
